import React from "react";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { PayInfoDetailProps } from "../PayInfoDetail";
import {
  PayDetailItem,
  PayDetailItemChildText,
  PayDetailItemText,
} from "./PartyFeePay";

export default function PartyEndRew({
  data,
  isNewVersion,
}: PayInfoDetailProps) {
  const exitDepositTotal = isNewVersion
    ? data?.log?.exit_deposit?.reduce(
        (sum, currValue) => sum + currValue.val,
        0
      )
    : data?.log?.amount - data?.log?.reward;
  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>추가 적립 혜택</PayDetailItemText>

        <PayDetailItemText>
          {(isNewVersion ? data?.log?.exit_deposit : data?.log?.members)
            ?.length > 0
            ? "중도 탈퇴 보상금"
            : "보증금 반환"}
        </PayDetailItemText>

        {(isNewVersion ? data?.log?.exit_deposit : data?.log?.members)?.map(
          (m, index: number) => (
            <PayDetailItemChildText key={index}>
              파티원_{m?.uid}
            </PayDetailItemChildText>
          )
        )}
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.reward)}
        </PayDetailItemText>

        <PayDetailItemText>
          {(isNewVersion ? data?.log?.exit_deposit : data?.log?.members)
            ?.length > 0
            ? GetMoneyValue(exitDepositTotal)
            : GetMoneyValue(data?.log?.deposit)}
        </PayDetailItemText>

        {(isNewVersion ? data?.log?.exit_deposit : data?.log?.members)?.map(
          (m, index: number) => (
            <PayDetailItemChildText key={index}>
              {GetMoneyValue(m?.val)}
            </PayDetailItemChildText>
          )
        )}
      </PayDetailItem>
    </>
  );
}
